import { Component, OnInit, Input, Injector } from '@angular/core';
import { EventsService } from '../../core/services/events-service/events.service';
import {
	NG_VALUE_ACCESSOR,
	ControlValueAccessor,
	NgControl,
} from '@angular/forms';
import { tap } from 'rxjs/operators';

@Component({
	selector: 'eze-event-image-upload',
	templateUrl: './event-image-upload.component.html',
	styleUrls: ['./event-image-upload.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: EventImageUploadComponent,
		},
	],
})
export class EventImageUploadComponent implements OnInit, ControlValueAccessor {
	@Input()
	eventId = '';

	@Input()
	showValidation = false;

	@Input()
	buttonLabel = 'Upload Image';

	@Input()
	uploadType = 'image';

	acceptableFiles = 'image/jpeg, image/png, application/pdf';

	imgSrc: string | ArrayBuffer;

	imageId = '';

	ngControl: NgControl;

	success = false;
	uploading = false;

	get isControlInvalid(): boolean {
		if (this.ngControl) {
			return this.ngControl.invalid;
		}
		return false;
	}

	get buttonContext(): string {
		if (this.isControlInvalid && this.showValidation) {
			return 'danger';
		}
		return 'primary';
	}

	onChange: (value: any) => void;
	onTouched: () => void;

	uploadError = false;

	constructor(
		private eventService: EventsService,
		private injector: Injector
	) {}

	ngOnInit() {
		this.ngControl = this.injector.get(NgControl);
	}

	onFileChange(event) {
		this.uploadError = false;

		if (event.target.files && event.target.files.length > 0) {
			const [file] = event.target.files;
			this.uploadFile(file);
		}
	}

	uploadFile(file: File) {
		let observable;

		this.uploading = true;
		this.success = false;

		if (this.uploadType === 'document') {
			const formData = new FormData();
			formData.append('document', file, file.name);
			observable = this.eventService.postRegistrationDocument(
				this.eventId,
				formData
			);
		} else {
			const formData = new FormData();
			formData.append('image', file, file.name);
			observable = this.eventService.postRegistrationImage(
				this.eventId,
				formData
			);
		}

		observable
			.pipe(
				tap(
					() => (this.uploading = false),
					() => (this.uploading = false)
				)
			)
			.subscribe(
				(event: { id: string }) => {
					this.setImageId(event.id);
					this.showPreview(file);
					this.success = true;
				},
				(err) => {
					this.uploadError = true;
				}
			);
	}

	showPreview(file: File) {
		if (this.uploadType !== 'image') {
			return;
		}
		const reader = new FileReader();

		reader.readAsDataURL(file);

		reader.onload = () => {
			this.imgSrc = reader.result;
		};
	}

	setImageId(id) {
		this.imageId = id;
		if (this.onChange) {
			this.onChange(id);
		}
	}

	writeValue(value) {
		this.imageId = value;
	}

	registerOnChange(fn) {
		this.onChange = fn;
	}

	registerOnTouched(fn) {
		this.onTouched = fn;
	}
}
